// extracted by mini-css-extract-plugin
export default {"eChart":"eChart_eChart__zt4B7"};